import { useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { Row, Col, Typography, Divider } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

import colors from "../../../../../colors";
import CustomIcon from "../../../../app/generic/customIcon";
import CheckboxItem from "../../../../app/generic/form/checkboxItem";

import "./index.css";

const { Text, Paragraph } = Typography;

const Product = ({
  last,
  textId,
  labelId,
  fieldName,
  infoTextId,
  countOfItems,
  formItemLayout,
  textDefaultMessage,
  labelDefaultMessage,
  infoTextDefaultMessage,
}) => {
  const data = useMemo(
    () =>
      [...Array(countOfItems).keys()].map((i) => (
        <FormattedMessage id={`${labelId}.item.${i}`} defaultMessage={`${i}`} />
      )),
    [labelId, countOfItems]
  );

  return (
    <Row>
      <Col>
        <CheckboxItem
          fieldName={fieldName}
          formItemLayout={formItemLayout}
          checkboxLabel={
            <Text strong>
              <FormattedMessage
                id={labelId}
                defaultMessage={labelDefaultMessage}
              />
            </Text>
          }
        />
        <Paragraph>
          <CustomIcon
            size={15}
            marginRight={10}
            color={colors.YELLOW}
            icon={InfoCircleOutlined}
          />
          <FormattedMessage
            id={infoTextId}
            defaultMessage={infoTextDefaultMessage}
          />
        </Paragraph>
        <Paragraph>
          <FormattedMessage id={textId} defaultMessage={textDefaultMessage} />
        </Paragraph>
        {countOfItems > 0 ? (
          <ul>
            {data.map((i, idx) => (
              <li key={idx}>
                <Text>{i}</Text>
              </li>
            ))}
          </ul>
        ) : (
          <></>
        )}
        {!last && <Divider />}
      </Col>
    </Row>
  );
};

export default Product;
